export default "__VITE_ASSET__DLwSn7Ur__"